/**
 * @fileoverview ESM mirror of ../buildTenantWebUrl.js.
 *
 * See the CJS source for full documentation. Drift between the two is
 * caught by `tests/unit/esmParity.behaviour.test.js` (a differential over
 * both halves) and `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/buildTenantWebUrl
 */

import { composeTenantOrigin, assertSafeRelativePath } from './tenantOrigin.js';

const CALLER = 'buildTenantWebUrl';

const SUBDOMAIN_LABEL_REGEX = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i;

function buildTenantWebUrl(args) {
  if (!args || typeof args !== 'object') {
    throw new Error(`${CALLER}: arguments object is required`);
  }
  const { target, subdomain, path, local, envPrefix } = args;

  if (!target || typeof target !== 'object') {
    throw new Error(`${CALLER}: target is required`);
  }
  if (typeof target.defaultDomain !== 'string' || target.defaultDomain.length === 0) {
    throw new Error(`${CALLER}: target.defaultDomain is required`);
  }
  if (typeof subdomain !== 'string' || !SUBDOMAIN_LABEL_REGEX.test(subdomain)) {
    throw new Error(`${CALLER}: subdomain must be one hostname label (alnum + inner hyphens)`);
  }
  if (typeof local !== 'boolean') {
    throw new Error(`${CALLER}: local is required (true on a localhost workstation)`);
  }
  assertSafeRelativePath(path, `${CALLER}: path`);

  const origin = composeTenantOrigin({ target, subdomain, envPrefix, local, caller: CALLER });
  return `${origin}${path}`;
}

export { buildTenantWebUrl };
